import { render, staticRenderFns } from "./BanksPayments.vue?vue&type=template&id=7c9b1a36"
import script from "./BanksPayments.vue?vue&type=script&lang=js"
export * from "./BanksPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports